import React, { useState } from "react";
import { Container, Row, Col, Table, Image, Modal } from "react-bootstrap";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import SlidingComponent from "../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { TextField, FormControl, Select, InputLabel } from "@material-ui/core";
import { NavLink } from "react-router-dom";

function SuperAdminNonProfitOrg(props) {
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <Container fluid>
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-3 col">
                  <div className="f24_700_HelveticaNeue ">
                    All Non- Profit Organization
                  </div>
                  <NavLink
                    class="btn btn-danger btn2 btn-lg"
                    to="/superadminaddnonprofitorg"
                  >
                    + Add Non-Profit
                  </NavLink>
                </div>
              </div>
              <div>
                <Row>
                  <Col md={3}>
                    <div className="filter-button-search">
                      <Paper component="form" className="enSearch2 d-flex">
                        <IconButton type="submit" aria-label="search">
                          <SearchIcon />
                        </IconButton>
                        <InputBase
                          placeholder="Search"
                          name="search"
                          inputProps={{
                            "aria-label": "Search",
                          }}
                          //   onChange={onSearchChange}
                          //   value={state.search}
                        />
                      </Paper>
                    </div>
                  </Col>
                  <Col md={6}></Col>
                  <Col md={3} align="right">
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="text-blue f15-500 mr-3">Sort by</div>

                      <FormControl variant="filled" className="enSortSelect">
                        <Select
                          //   value={props.sortBy}
                          //   onChange={props.handleChangeCode}
                          inputProps={{
                            name: "SortBy",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <option value="namea-z">Name A-Z</option>
                          <option value="namez-a">Name Z-A</option>
                        </Select>
                      </FormControl>
                      {/* <div className="d-flex align-items-center"> */}
                      <div className="text-blue f15-500 ml-5 mr-3">Filters</div>
                      <IconButton className="enDownIcon">
                        <Image
                          src={require("../../../../assets/images/UserManagement/chevron-down.svg")}
                          alt="View"
                          title="View"
                        />
                      </IconButton>
                    </div>
                    {/* </div> */}
                  </Col>
                </Row>
                <div className="user-table-reusable-superadmin table-responsive">
                  <Table>
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "10%" }} className="f12-700">
                          Non-Profit <br />
                          ID
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Non-Profit Name
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Primary Contact
                        </th>
                        <th style={{ width: "25%" }} className="f12-700">
                          Address
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Organization type
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Status
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <DataToDisp />
                    </tbody>
                  </Table>
                </div>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const DataToDisp = (props) => {
  const [showMore, setshowMore] = useState(false);
  return (
    <tr
      className="super_admin_all_users_table_body mt-2"
      style={{ wordBreak: "break-word" }}
    >
      <td colSpan="7" className="p-0 w-100">
        <table className="w-100 HideShowTable enMinWidth900">
          <tbody>
            <tr
              onClick={() => {
                setshowMore(!showMore);
              }}
              style={{ cursor: "pointer" }}
            >
              <td style={{ width: "10%" }}>
                <div className="image-box">
                  <div className="Image-box-section">
                    <img
                      alt="Restaurant Photo"
                      title="Restaurant Photo"
                      src="https://amealia.s3.amazonaws.com/6023a078ff3504266385ee28_Alfanzo-Alfanzo.png"
                      className="img-fluid"
                      width="45px"
                    />
                  </div>
                  <div>
                    <h5 className="font_16_m mt-2">#101</h5>
                  </div>
                </div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f12-500">McDonalds</div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f12-500">
                  Kinza <br />
                  kinza123@gmail.com
                  <br /> +91 8412854363
                </div>
              </td>
              <td style={{ width: "25%" }}>
                <div className="f12-500">
                  Survey No:32/2, Gurukrupa hall near Dmart, Ambegaon BK Pune,
                  Maharashtra 411046
                </div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f12-500">-</div>
              </td>
              <td style={{ width: "10%" }}>
                <SlidingComponent
                  name="has_admin_approved"
                  currentState={true}
                  type={"checkbox"}
                  toggleclass={
                    "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                  }
                  toggleinputclass={"toggle__switch vendor-super-admin-toggle"}
                  onChange={() => {}}
                  defaultChecked={true}
                />
              </td>
              <td style={{ width: "15%" }}>
                <div className="d-flex">
                  <div className="enIconBtn mr-3">
                    <Image
                      src={require("../../../../assets/images/UserManagement/Delete.svg")}
                      alt="Delete"
                      title="Delete"
                      fluid
                    />
                  </div>
                  <ViewModel />
                  <div className="enIconBtn mr-3">
                    <Image
                      src={require("../../../../assets/images/UserManagement/pencil.svg")}
                      alt="Edit"
                      title="Edit"
                      fluid
                    />
                  </div>
                </div>
              </td>
            </tr>
            {showMore && (
              <>
                <hr />
                <tr>
                  <td style={{ width: "25%" }}>
                    {" "}
                    <div className="f12-500">Contact</div>
                    <div className="d-flex mt-3">
                      <div className="enIconBtn mr-3">
                        <Image
                          src={require("../../../../assets/images/UserManagement/Delete.svg")}
                          alt="Delete"
                          title="Delete"
                          fluid
                        />
                      </div>
                      <div className="enIconBtn mr-3">
                        <Image
                          src={require("../../../../assets/images/UserManagement/Delete.svg")}
                          alt="Delete"
                          title="Delete"
                          fluid
                        />
                      </div>
                      <div className="enIconBtn mr-3">
                        <Image
                          src={require("../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </div>
                      <div className="enIconBtn mr-3">
                        <Image
                          src={require("../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="f12-500">City</div>
                    <div className="f12-400 mt-3">Pune</div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="f12-500">Location</div>
                    <div className="f12-400 mt-3">Hadapsar Post</div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="f12-500">Member Since</div>
                    <div className="f12-400 mt-3">25/08/2020</div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="f12-700 text-danger">Member Since</div>
                    <div className=" mt-3">
                      <div className="d-flex">
                        <div className="enIconBtn mr-3">
                          <Image
                            src={require("../../../../assets/images/UserManagement/eye.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </div>
                        <div className="enIconBtn mr-3">
                          <Image
                            src={require("../../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </div>
                        <div className="enIconBtn mr-3">
                          <Image
                            src={require("../../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </td>
    </tr>
  );
};

const ViewModel = (props) => {
  const [show, setShow] = useState(false);
  return (
    <div>
      <div
        className="enIconBtn mr-3"
        onClick={() => {
          setShow(true);
        }}
      >
        <Image
          src={require("../../../../assets/images/UserManagement/eye.svg")}
          alt="Edit"
          title="Edit"
          fluid
        />
      </div>
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
        }}
        centered
        size="lg"
        className="admin_vendor_details_popup"
      >
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title className="modal_title_header">
            Non Profit Organization Profile
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-1">
              <Image src="https://amealia.s3.amazonaws.com/6023a078ff3504266385ee28_Alfanzo-Alfanzo.png"
                     alt="restaurant"
                     title="restaurant"
                     fluid />
            </div>
            <div className="col-2 ">
              <div className="f12-500">Mcdonalds’</div>
              <div className="f12-400">
                Hours of Openings <br />
                08:00 am to 10:00 pm
              </div>
            </div>
            <div className="col-6 "></div>
            <div className="col-3 ">
              <div className="d-flex">
                <div
                  className="enIconBtn mr-3"
                  onClick={() => {
                    setShow(true);
                  }}
                >
                  <Image
                    src={require("../../../../assets/images/UserManagement/phone.svg")}
                    alt="Edit"
                    title="Edit"
                    fluid
                  />
                </div>
                <div
                  className="enIconBtn mr-3"
                  onClick={() => {
                    setShow(true);
                  }}
                >
                  <Image
                    src={require("../../../../assets/images/UserManagement/forum.svg")}
                    alt="Edit"
                    title="Edit"
                    fluid
                  />
                </div>
              </div>
              <div className="d-flex mt-3">
                <div
                  className="enIconBtn mr-3"
                  onClick={() => {
                    setShow(true);
                  }}
                >
                  <Image
                    src={require("../../../../assets/images/UserManagement/email.svg")}
                    alt="Edit"
                    title="Edit"
                    fluid
                  />
                </div>
                <div
                  className="enIconBtn mr-3"
                  onClick={() => {
                    setShow(true);
                  }}
                >
                  <Image
                    src={require("../../../../assets/images/UserManagement/notification.svg")}
                    alt="Edit"
                    title="Edit"
                    fluid
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="f18-500" style={{ color: "#EE3A23" }}>
            Non Profit Organization
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Business Name</div>
              <div className="mt-2 mb-2 f14-400">Street Treat</div>
            </div>
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Phone No.</div>
              <div className="mt-2 mb-2 f14-400">+91 123456789</div>
            </div>
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Business Address</div>
              <div className="mt-2 mb-2 f14-400">
                344 Clinton., Apt. 3B, Metropolis, USA (later 1938 Sullivan
                Lane, Metropolis)
              </div>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Area</div>
              <div className="mt-2 mb-2 f14-400">Koregaon Park</div>
            </div>
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">City</div>
              <div className="mt-2 mb-2 f14-400">Pune</div>
            </div>
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Enquiry Email</div>
              <div className="mt-2 mb-2 f14-400">John.doe77@restaurant.in</div>
            </div>
          </div>
          <hr />
          <div className="row mt-3 mb-3">
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Pin/Zip code</div>
              <div className="mt-2 mb-2 f14-400">411001</div>
            </div>
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Country</div>
              <div className="mt-2 mb-2 f14-400">India</div>
            </div>
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Currency</div>
              <div className="mt-2 mb-2 f14-400">INR (Indian Rupees)</div>
            </div>
          </div>
          <hr />
          <div className="row mt-3 mb-3">
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Time zone</div>
              <div className="mt-2 mb-2 f14-400">IST</div>
            </div>
          </div>
          <div className="f18-500" style={{ color: "#EE3A23" }}>
            Point of contact
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Name</div>
              <div className="mt-2 mb-2 f14-400">John Doe</div>
              <div className="mt-2 mb-2 f14-400">(General Manager)</div>
            </div>
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Enquiry Email</div>
              <div className="mt-2 mb-2 f14-400">John.doe77@restaurant.in</div>
            </div>
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Phone No.</div>
              <div className="mt-2 mb-2 f14-400">+91 8412555644</div>
              <div className="mt-2 mb-2 f14-400">+91 8976543210</div>
            </div>
          </div>
          <div className="f18-500" style={{ color: "#EE3A23" }}>
            Non Profit Organization Details
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Business Description</div>
              <div className="mt-2 mb-2 f14-400">
                Your restaurant description gives potential customers a window
                into what it’s like to dine at your restaurant. You can use the
                space to talk about anything, but we recommend starting with
                what the experience of eating at your restaurant is like, what
                influences the cuisine, or spotlighting any signature dishes.
              </div>
            </div>
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Logo</div>
              <div className="mt-2 mb-2 f14-400">
                <Image src="" />
              </div>
            </div>
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Photos</div>
              <div className="mt-2 mb-2 f14-400">
                <Image src="" width="75px" />
                <Image src="" width="75px" />
              </div>
              <div className="mt-2 mb-2 f14-400">
                <Image src="" width="75px" />
                <Image src="" width="75px" />
              </div>
            </div>
          </div>
          <div className="f14-500">Video</div>
          <div className="">
            <video src="" width="110px"></video>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Business Type</div>
              <div className="mt-2 mb-2 f14-400">
                Fine dining, Cafés, Bars/pubs, Casual dining.
              </div>
            </div>
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">Bank Details</div>
              <div className="mt-2 mb-2 f14-400">Account Number</div>
              <div className="mt-2 mb-2 f14-400">Documents</div>
              <div className="mt-2 mb-2 f14-400">
                <Image src="" />
              </div>
            </div>
            <div className="col-4">
              <div className="mt-2 mb-2 f14-500">KYC and License Info</div>
              <div className="mt-2 mb-2 f14-400">GST Number</div>
              <div className="mt-2 mb-2 f14-400">Non- Number</div>
              <div className="mt-2 mb-2 f14-400">PAN/ Tax Number</div>
              <div className="mt-2 mb-2 f14-400">Documents</div>
              <div className="mt-2 mb-2 f14-400">
                <Image src="" width="75px" />
                <Image src="" width="75px" />
              </div>
              <div className="mt-2 mb-2 f14-400">
                <Image src="" width="75px" />
                <Image src="" width="75px" />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SuperAdminNonProfitOrg;
